(function($) {
	// Get Window Width and Height
	var windowWidth = $(window).outerWidth();
	var windowHeight = $(window).height();

	/* Document ready functions */
	$(document).ready(function (){


		$('.mMenu').on('click', function(){
			if($('html, body').hasClass('navOpen')) {
				$('html, body').removeClass('navOpen');
			} else {
				$('html, body').addClass('navOpen');
			}
		});

    // Menu navigation
    $(".menu-item-has-children").each(function(){
		var empty_a = $(this).children().first();
		var empty_a_text = $(this).children().first().text();
		empty_a.replaceWith( '<div class="parent">'+empty_a_text+'</div>' );
      $(this).on("click", function() {
        if($('html, body').hasClass('navOpen')) {
          if($(this).hasClass('show-children')) {
						$(".menu-item-has-children").removeClass('show-children');
            $(this).removeClass('show-children');
          }
					else if($(this).hasClass('current-page-parent')) {
						$(".menu-item-has-children").removeClass('show-children');
            $(this).removeClass('show-children current-page-parent');
          } else {
						$(".menu-item-has-children").removeClass('show-children');
            $(this).addClass('show-children');
          }
        } else {
          if($(this).hasClass('show-children')) {
            $(this).removeClass('show-children');
          } else {
						$(".menu-item-has-children").removeClass('show-children');
            $(this).addClass('show-children');
          }
        }

      });
    });

		// Open links on click in other facilities swiper list.
		$("a.puff-link").each(function(){
		  $(this).on("click", function() {
				window.location = $(this).attr('href');
			});
		});

		// Smooth scroll to anchor
    $(document).on('click', '.section a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 500);
    });

		// Scroll to Anchor on page load
		var url = window.location.hash;
		var hash = url.substring(url.indexOf('#') + 1, url.length);
		if (hash !== "") {
			setTimeout(function() {
				$('html, body').animate({
					scrollTop: $("#"+hash).offset().top
				}, 500);
			},700);
		}

	});

	$(window).resize(function () {

		// Get Window Width and Height on resize
		windowWidth = $(window).outerWidth();
		windowHeight = $(window).height();

    if(windowWidth > 1023) {
  		$('html, body').removeClass('navOpen');
  	}

	});

})(jQuery);
